"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectFormCategoryVariantEnum = exports.FolderKeyEnum = exports.ProjectFormCategoryEnum = exports.ProjectFormTypeEnum = exports.UsageMethodEnum = exports.TaskQueryStatus = exports.TechnicalFormStatusEnum = exports.ProjectFormRichTextHelpTypeEnum = exports.ProjectFormEnum = exports.UserStatusEnum = exports.UserRoleEnum = void 0;
/**
 * USERS
 */
var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["ADMIN"] = "admin";
    UserRoleEnum["USER"] = "user";
})(UserRoleEnum || (exports.UserRoleEnum = UserRoleEnum = {}));
var UserStatusEnum;
(function (UserStatusEnum) {
    UserStatusEnum["ACTIVE"] = "active";
    UserStatusEnum["INACTIVE"] = "inactive";
    UserStatusEnum["INVITED"] = "invited";
})(UserStatusEnum || (exports.UserStatusEnum = UserStatusEnum = {}));
/**
 * Project (form)
 */
var ProjectFormEnum;
(function (ProjectFormEnum) {
    // BUILDING PERMIT
    ProjectFormEnum["ACCOMPANYING_REPORT_FORM_A1"] = "ACCOMPANYING_REPORT_FORM_A1";
    ProjectFormEnum["TECHNICAL_FORM_B1"] = "TECHNICAL_FORM_B1";
    ProjectFormEnum["TECHNICAL_FORM_B2"] = "TECHNICAL_FORM_B2";
    ProjectFormEnum["TECHNICAL_FORM_B3"] = "TECHNICAL_FORM_B3";
    ProjectFormEnum["TECHNICAL_FORM_B4"] = "TECHNICAL_FORM_B4";
    ProjectFormEnum["TECHNICAL_FORM_B5"] = "TECHNICAL_FORM_B5";
    ProjectFormEnum["TECHNICAL_FORM_B6"] = "TECHNICAL_FORM_B6";
    ProjectFormEnum["TECHNICAL_FORM_B7"] = "TECHNICAL_FORM_B7";
    ProjectFormEnum["TECHNICAL_FORM_B8"] = "TECHNICAL_FORM_B8";
    ProjectFormEnum["TECHNICAL_FORM_B9"] = "TECHNICAL_FORM_B9";
    ProjectFormEnum["TECHNICAL_FORM_B10"] = "TECHNICAL_FORM_B10";
    // DEMOLITION PERMIT
    ProjectFormEnum["DEMOLITION_ACCOMPANYING_REPORT_FORM_A1"] = "DEMOLITION_ACCOMPANYING_REPORT_FORM_A1";
    ProjectFormEnum["DEMOLITION_TECHNICAL_FORM_B1"] = "DEMOLITION_TECHNICAL_FORM_B1";
    ProjectFormEnum["DEMOLITION_TECHNICAL_FORM_B2"] = "DEMOLITION_TECHNICAL_FORM_B2";
    ProjectFormEnum["DEMOLITION_TECHNICAL_FORM_B3"] = "DEMOLITION_TECHNICAL_FORM_B3";
    ProjectFormEnum["DEMOLITION_TECHNICAL_FORM_B4"] = "DEMOLITION_TECHNICAL_FORM_B4";
    // OTHER
    ProjectFormEnum["CONSTRUCTION_DIARY_FORM"] = "CONSTRUCTION_DIARY_FORM";
})(ProjectFormEnum || (exports.ProjectFormEnum = ProjectFormEnum = {}));
var ProjectFormRichTextHelpTypeEnum;
(function (ProjectFormRichTextHelpTypeEnum) {
    ProjectFormRichTextHelpTypeEnum["CUSTOM"] = "CUSTOM";
    ProjectFormRichTextHelpTypeEnum["SHARED"] = "SHARED";
})(ProjectFormRichTextHelpTypeEnum || (exports.ProjectFormRichTextHelpTypeEnum = ProjectFormRichTextHelpTypeEnum = {}));
var TechnicalFormStatusEnum;
(function (TechnicalFormStatusEnum) {
    TechnicalFormStatusEnum["EDIT"] = "EDIT";
    TechnicalFormStatusEnum["PREVIEW"] = "PREVIEW";
    TechnicalFormStatusEnum["DONE"] = "DONE";
})(TechnicalFormStatusEnum || (exports.TechnicalFormStatusEnum = TechnicalFormStatusEnum = {}));
var TaskQueryStatus;
(function (TaskQueryStatus) {
    TaskQueryStatus["DONE"] = "done";
    TaskQueryStatus["NOT_DONE"] = "not-done";
    TaskQueryStatus["ALL"] = "all";
})(TaskQueryStatus || (exports.TaskQueryStatus = TaskQueryStatus = {}));
var UsageMethodEnum;
(function (UsageMethodEnum) {
    UsageMethodEnum["SINGLE_RESIDENTIAL"] = "1.1.1.0.1.1 Budovy jednobytov\u00E9";
    UsageMethodEnum["SINGLE_RESIDENTIAL_WITH_SERVICE"] = "1.1.1.0.1.2 Budovy jednobytov\u00E9 se slu\u017Eebn\u00EDm vybaven\u00EDm";
    UsageMethodEnum["VACATION_HOUSE_SINGLE"] = "1.1.1.0.2.1 Chalupy pro rekreaci jednobytov\u00E9";
    UsageMethodEnum["VACATION_COTTAGE_SINGLE"] = "1.1.1.0.2.2 Chaty pro rekreaci jednobytov\u00E9";
    UsageMethodEnum["BUILDING_FENCE_SINGLE"] = "1.1.1.0.9.1 Oplocen\u00ED budov 1110";
    UsageMethodEnum["TWO_RESIDENTIAL"] = "1.1.2.1.1.1 Budovy dvoubytov\u00E9";
    UsageMethodEnum["TWO_RESIDENTIAL_WITH_SERVICE"] = "1.1.2.1.1.2 Budovy dvoubytov\u00E9 se slu\u017Eebn\u00EDm vybaven\u00EDm";
    UsageMethodEnum["VACATION_HOUSE_DOUBLE"] = "1.1.2.1.2.1 Chalupy pro rekreaci dvoubytov\u00E9";
    UsageMethodEnum["VACATION_COTTAGE_DOUBLE"] = "1.1.2.1.2.2 Chaty pro rekreaci dvoubytov\u00E9";
    UsageMethodEnum["BUILDING_FENCE_DOUBLE"] = "1.1.2.1.9.1 Oplocen\u00ED budov 1121";
    UsageMethodEnum["THREE_RESIDENTIAL_TYPICAL"] = "1.1.2.2.1.3 Budovy t\u0159\u00EDbytov\u00E9 \u2013 typov\u00E9";
    UsageMethodEnum["THREE_RESIDENTIAL_ATYPICAL"] = "1.1.2.2.1.4 Budovy t\u0159\u00EDbytov\u00E9 \u2013 netypov\u00E9";
    UsageMethodEnum["MULTI_RESIDENTIAL_TYPICAL"] = "1.1.2.2.1.5 Budovy \u010Dty\u0159 a v\u00EDcebytov\u00E9 \u2013 typov\u00E9";
    UsageMethodEnum["MULTI_RESIDENTIAL_ATYPICAL"] = "1.1.2.2.1.6 Budovy \u010Dty\u0159 a v\u00EDcebytov\u00E9 \u2013 netypov\u00E9";
    UsageMethodEnum["VACATION_HOUSES_MULTI"] = "1.1.2.2.2.1 Chalupy pro rekreaci t\u0159\u00ED a v\u00EDcebytov\u00E9";
    UsageMethodEnum["VACATION_COTTAGES_MULTI"] = "1.1.2.2.2.2 Chaty pro rekreaci t\u0159\u00ED a v\u00EDcebytov\u00E9";
    UsageMethodEnum["BUILDING_FENCE_MULTI"] = "1.1.2.2.9.1 Oplocen\u00ED budov 1122";
    UsageMethodEnum["OTHER_RESIDENTIAL_SOCIAL"] = "1.1.3.0.1.1 Budovy se slu\u017Ebami soci\u00E1ln\u00ED p\u00E9\u010De";
    UsageMethodEnum["OTHER_RESIDENTIAL_STUDENT"] = "1.1.3.0.1.2 Budovy pro ubytov\u00E1n\u00ED student\u016F, zam\u011Bstnanc\u016F apod.";
    UsageMethodEnum["OTHER_RESIDENTIAL_OTHER"] = "1.1.3.0.1.9 Budovy bytov\u00E9 ostatn\u00ED j. n.";
    UsageMethodEnum["BUILDING_FENCE_OTHER"] = "1.1.3.0.9.1 Oplocen\u00ED budov 1130";
})(UsageMethodEnum || (exports.UsageMethodEnum = UsageMethodEnum = {}));
var ProjectFormTypeEnum;
(function (ProjectFormTypeEnum) {
    ProjectFormTypeEnum["BUILDING_PERMIT_ACCOMPANYING_REPORT"] = "BUILDING_PERMIT_ACCOMPANYING_REPORT";
    ProjectFormTypeEnum["BUILDING_PERMIT_TECHNICAL_FORM"] = "BUILDING_PERMIT_TECHNICAL_FORM";
    ProjectFormTypeEnum["DEMOLITION_PERMIT_ACCOMPANYING_REPORT"] = "DEMOLITION_PERMIT_ACCOMPANYING_REPORT";
    ProjectFormTypeEnum["DEMOLITION_PERMIT_TECHNICAL_FORM"] = "DEMOLITION_PERMIT_TECHNICAL_FORM";
})(ProjectFormTypeEnum || (exports.ProjectFormTypeEnum = ProjectFormTypeEnum = {}));
var ProjectFormCategoryEnum;
(function (ProjectFormCategoryEnum) {
    ProjectFormCategoryEnum["BUILDING_PERMIT"] = "building-permit";
    ProjectFormCategoryEnum["DEMOLITION_PERMIT"] = "demolition-permit";
})(ProjectFormCategoryEnum || (exports.ProjectFormCategoryEnum = ProjectFormCategoryEnum = {}));
var FolderKeyEnum;
(function (FolderKeyEnum) {
    FolderKeyEnum["PROJECT_ROOT"] = "PROJECT_ROOT";
    FolderKeyEnum["ENGINEERING"] = "ENGINEERING";
    FolderKeyEnum["CONSTRUCTION_DIARY"] = "CONSTRUCTION_DIARY";
    // Building permit
    FolderKeyEnum["PROJECT_FORM_ATTACHMENTS"] = "PROJECT_FORM_ATTACHMENTS";
    FolderKeyEnum["PROJECT_RESEARCH_AND_SURVEYS"] = "PROJECT_RESEARCH_AND_SURVEYS";
    FolderKeyEnum["PROJECT_SITUATION_DOCUMENTATION"] = "PROJECT_SITUATION_DOCUMENTATION";
    FolderKeyEnum["OBJECT_DOCUMENTATION"] = "OBJECT_DOCUMENTATION";
    // Demolition permit
    FolderKeyEnum["DEMOLITION_FORM_ATTACHMENTS"] = "DEMOLITION_FORM_ATTACHMENTS";
    FolderKeyEnum["DEMOLITION_RESEARCH_AND_SURVEYS"] = "DEMOLITION_RESEARCH_AND_SURVEYS";
    FolderKeyEnum["DEMOLITION_SITUATION_DOCUMENTATION"] = "DEMOLITION_SITUATION_DOCUMENTATION";
    FolderKeyEnum["DEMOLITION_OBJECT_DOCUMENTATION"] = "DEMOLITION_OBJECT_DOCUMENTATION";
})(FolderKeyEnum || (exports.FolderKeyEnum = FolderKeyEnum = {}));
var ProjectFormCategoryVariantEnum;
(function (ProjectFormCategoryVariantEnum) {
    ProjectFormCategoryVariantEnum["OFF"] = "off";
    ProjectFormCategoryVariantEnum["UPLOAD"] = "upload";
    ProjectFormCategoryVariantEnum["CREATE"] = "create";
})(ProjectFormCategoryVariantEnum || (exports.ProjectFormCategoryVariantEnum = ProjectFormCategoryVariantEnum = {}));
